export const primary_key = 'location' as const;

/**
 * @example
 *  - ['location']
 *  - ['location', 'list', <filters>]
 *  - ['location', 'detail', <id>]
 */
const LocationQueryKeys = {
  all: () => [primary_key] as const,
  list: (filters?: Record<string, unknown>) =>
    [
      ...LocationQueryKeys.all(),
      'list',
      ...(filters ? [filters] : [])
    ] as const,
  detail: (id: number) => [...LocationQueryKeys.all(), 'detail', id] as const
};

export default LocationQueryKeys;
